import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useSearchBatchListStore = defineStore(
  'batch', 
  () => {
    const searchParams = ref([])
    
    function searchParamsData(data){
      searchParams.value = data
    }

    return { searchParams , searchParamsData}
  },
  {
    persist: true
  },
)